/* GEGENEREERD BESTAND - niet met de hand bewerken.
   Bron: customizer/src/templates.js + brand/logo.svg + src/font-catalog.js
   Opnieuw maken: cd customizer && node scripts/export-geometry.mjs
   Alle maten in millimeters. */
window.SCKR_GEOMETRY = {
  "version": 1,
  "dpi": 300,
  "a4Mm": {
    "w": 210,
    "h": 297
  },
  "defaultBleedMm": {
    "x": 5,
    "y": 5
  },
  "sizes": [
    "8cm",
    "10cm",
    "12cm"
  ],
  "templates": {
    "8cm": {
      "label": "8 cm",
      "productLengthMm": 80,
      "artboardMm": {
        "w": 78.242,
        "h": 100.765
      },
      "shapeMm": {
        "w": 68.242,
        "h": 90.765
      },
      "bleedMm": {
        "x": 5,
        "y": 5
      },
      "contour": "M38.7397 5.0015 C73.1567 4.7898 73.1567 26.3375 73.2414 30.0205 C73.3091 32.9669 65.6495 67.288 61.8114 84.0802 C60.2969 88.2866 54.0589 95.6703 39.0267 95.7635 C39.1216 95.7643 39.2169 95.7652 39.3125 95.7652 L38.7397 95.7643 C38.8357 95.7643 38.9314 95.7635 39.0267 95.7635 C24.1307 95.6102 17.9385 88.2705 16.4304 84.0818 C12.5923 67.2895 4.9327 32.9685 5.0004 30.0221 C5.0846 26.3632 5.0851 5.0733 38.8294 5.0017 L38.7397 5.0015 Z",
      "logo": {
        "xMm": 27.607,
        "yMm": 80.523,
        "wMm": 23.028,
        "hMm": 4.163
      }
    },
    "10cm": {
      "label": "10 cm",
      "productLengthMm": 100,
      "artboardMm": {
        "w": 92.331,
        "h": 118.416
      },
      "shapeMm": {
        "w": 82.331,
        "h": 108.416
      },
      "bleedMm": {
        "x": 5,
        "y": 5
      },
      "contour": "M46.1827 5 C46.1769 5.0001 46.1711 5.0002 46.1653 5.0002 C78.3254 5.438 88.9892 21.9778 87.1265 33.9137 C83.1328 52.9778 74.9853 91.8849 74.3419 95.0007 C73.5375 98.8945 71.1677 113.4089 46.1652 113.4157 C46.1711 113.4157 46.1769 113.4157 46.1827 113.4157 H46.1479 C46.1537 113.4157 46.1595 113.4157 46.1652 113.4157 C21.1626 113.4089 18.7928 98.8945 17.9887 95.0007 C17.3452 91.8849 9.1974 52.9778 5.204 33.9137 C3.3417 21.9778 14.0055 5.438 46.1653 5.0002 C46.1595 5.0002 46.1536 5.0001 46.1479 5 H46.1827 Z",
      "logo": {
        "xMm": 32.389,
        "yMm": 95.205,
        "wMm": 27.552,
        "hMm": 4.981
      }
    },
    "12cm": {
      "label": "12 cm",
      "productLengthMm": 120,
      "artboardMm": {
        "w": 109.78,
        "h": 138.024
      },
      "shapeMm": {
        "w": 99.78,
        "h": 128.024
      },
      "bleedMm": {
        "x": 5,
        "y": 5
      },
      "contour": "M5 36.3318 C6.4901 10.8641 38.9511 4.8477 54.9532 5.0029 C70.9994 4.8806 103.2938 10.9341 104.7797 36.3346 L92.757 112.1533 C91.4591 119.3466 81.1678 133.0101 54.9084 133.0236 C54.9092 133.0236 54.9102 133.0236 54.911 133.0236 H54.9057 C54.9066 133.0236 54.9074 133.0236 54.9084 133.0236 C28.6213 133.0228 18.3209 119.3474 17.0227 112.1508 L5 36.3318 Z",
      "logo": {
        "xMm": 36.285,
        "yMm": 111.097,
        "wMm": 37.21,
        "hMm": 6.726
      }
    }
  },
  "logo": {
    "aspect": 5.5319,
    "paths": [
      "M0.385892 0.073381 L0.420903 0.073373 C0.426645 0.073372 0.433257 0.072961 0.438883 0.073648 C0.45988 0.076213 0.469761 0.098448 0.460322 0.116603 C0.456947 0.123092 0.451479 0.127085 0.444677 0.129094 L0.464741 0.161653 L0.439792 0.161654 C0.435851 0.157343 0.432802 0.152738 0.429623 0.148359 C0.425223 0.1423 0.412257 0.120992 0.40707 0.117853 V0.161654 H0.385611 L0.385892 0.073381 ZM0.407043 0.11182 L0.435733 0.11182 C0.436365 0.111305 0.437387 0.110534 0.437876 0.10993 C0.438715 0.108902 0.439713 0.107717 0.440184 0.106485 C0.442075 0.101529 0.440404 0.095144 0.435627 0.092578 L0.408122 0.092555 C0.407339 0.0934 0.407107 0.093507 0.407062 0.094752 C0.406867 0.100424 0.40707 0.106147 0.407043 0.11182 Z",
      "M0.507983 0.073403 C0.509768 0.073179 0.518885 0.073343 0.521161 0.073344 L0.550121 0.073357 C0.547585 0.078772 0.5444 0.087536 0.54107 0.092226 C0.529165 0.093922 0.517986 0.090614 0.506546 0.093458 C0.500127 0.095053 0.498164 0.098683 0.495229 0.103956 L0.495266 0.107141 L0.550116 0.107143 V0.14353 V0.161659 L0.518789 0.16168 C0.515021 0.16168 0.505766 0.16193 0.502458 0.161335 C0.496727 0.159993 0.489054 0.157316 0.484648 0.153493 C0.466968 0.13816 0.465712 0.104628 0.480199 0.086861 C0.485601 0.080238 0.499549 0.074104 0.507983 0.073403 ZM0.527864 0.141493 C0.527869 0.139078 0.52822 0.127283 0.527472 0.12615 C0.525773 0.125475 0.522751 0.126221 0.520833 0.12634 C0.515068 0.126697 0.505171 0.127995 0.500692 0.123555 C0.498557 0.12144 0.495755 0.113244 0.493995 0.111207 C0.493957 0.120704 0.492555 0.130483 0.499426 0.138094 C0.501658 0.140567 0.507667 0.142912 0.510889 0.142551 C0.513259 0.142286 0.527035 0.142986 0.527854 0.142175 L0.527864 0.141493 Z",
      "M0.74557 0.073357 L0.780805 0.073351 C0.786791 0.073349 0.793581 0.07298 0.79938 0.073762 C0.81402 0.075738 0.82429 0.087694 0.824009 0.102478 C0.823752 0.11604 0.816933 0.125079 0.804006 0.128723 C0.806614 0.133219 0.809761 0.139037 0.812489 0.143321 C0.80825 0.141672 0.803631 0.138858 0.799733 0.136502 C0.789961 0.130598 0.779306 0.122367 0.768799 0.118055 C0.768273 0.117438 0.768226 0.11716 0.767557 0.11697 L0.767154 0.11728 C0.766792 0.120433 0.767053 0.12842 0.767058 0.132087 L0.767053 0.161659 H0.74557 V0.073357 ZM0.767046 0.111813 H0.795306 C0.796731 0.110987 0.797368 0.110343 0.79857 0.109232 C0.799005 0.108754 0.799738 0.107932 0.800079 0.107383 C0.802409 0.103627 0.800343 0.093258 0.795255 0.09271 C0.792687 0.092434 0.788389 0.092536 0.785572 0.092538 L0.767046 0.092556 V0.111813 Z",
      "M0.677176 0.073384 C0.678087 0.073194 0.679892 0.073302 0.680879 0.073235 C0.685387 0.072926 0.694193 0.074152 0.698265 0.073309 C0.702059 0.08268 0.707444 0.093889 0.711638 0.10325 L0.737822 0.161659 H0.715914 C0.712616 0.157848 0.71051 0.150661 0.707853 0.145872 C0.707187 0.145873 0.706518 0.145869 0.705851 0.145859 C0.700926 0.14578 0.689846 0.145729 0.684471 0.145195 C0.684212 0.144929 0.683992 0.144702 0.68381 0.144513 L0.673621 0.131711 C0.66877 0.140851 0.663597 0.152163 0.658998 0.161632 C0.653994 0.160938 0.638534 0.163412 0.635766 0.160887 C0.635882 0.158225 0.648249 0.131932 0.650031 0.127988 L0.67445 0.073978 C0.675327 0.073651 0.676253 0.073535 0.677176 0.073384 ZM0.675472 0.12638 H0.687693 C0.689157 0.126379 0.698111 0.126556 0.698657 0.126028 C0.698946 0.121996 0.690419 0.105531 0.687997 0.101586 C0.687807 0.101273 0.687098 0.10094 0.686718 0.100785 L0.675472 0.12638 Z",
      "M0.022228 0.073381 H0.079547 C0.078444 0.077965 0.073368 0.088682 0.070537 0.092438 L0.044023 0.092581 C0.039201 0.092574 0.034364 0.092456 0.029557 0.092556 C0.024509 0.09266 0.022267 0.096551 0.022551 0.101203 C0.022904 0.106999 0.027445 0.107556 0.032133 0.107597 C0.045729 0.107716 0.060524 0.104308 0.071976 0.113927 C0.077175 0.118273 0.079923 0.124529 0.080404 0.13126 C0.080887 0.138865 0.079093 0.147374 0.073921 0.153214 C0.069617 0.158073 0.06456 0.161131 0.058083 0.161653 L0.000935 0.161633 C0.002742 0.154651 0.005911 0.149031 0.009111 0.142624 C0.02184 0.140837 0.036189 0.144276 0.049086 0.142535 C0.054447 0.141812 0.058853 0.137925 0.05786 0.132323 C0.056248 0.123229 0.040205 0.126198 0.033779 0.12611 C0.029851 0.126394 0.026502 0.126281 0.022552 0.125967 C0.000591 0.124225 -0.005719 0.099105 0.005333 0.082652 C0.008484 0.077961 0.016364 0.074246 0.022228 0.073381 Z",
      "M0.941663 0.0734 C0.948163 0.073212 0.955212 0.073366 0.961771 0.073367 L0.999352 0.073357 C0.996789 0.079326 0.994328 0.085698 0.991286 0.091386 C0.99038 0.093077 0.982966 0.092528 0.980816 0.092532 L0.958041 0.092579 C0.951753 0.092586 0.941135 0.090388 0.942191 0.100882 C0.942455 0.103526 0.94468 0.106345 0.947304 0.107109 C0.956496 0.10979 0.966753 0.106945 0.976204 0.108027 C1.000078 0.109719 1.005978 0.134336 0.993967 0.152186 C0.990405 0.157481 0.985055 0.160483 0.978525 0.161522 C0.976905 0.161745 0.973469 0.161673 0.971733 0.16167 L0.960236 0.16165 L0.920833 0.161659 C0.922248 0.153798 0.92582 0.149792 0.928756 0.142629 L0.956836 0.142472 C0.961211 0.142447 0.965608 0.142417 0.970133 0.142419 C0.977201 0.142422 0.979949 0.132591 0.975621 0.128474 C0.972079 0.125105 0.962732 0.125898 0.957752 0.126182 C0.947645 0.126759 0.936486 0.127239 0.928149 0.1202 C0.912541 0.106512 0.919666 0.075223 0.941663 0.0734 Z",
      "M0.349529 0.073391 C0.358486 0.073237 0.368023 0.073384 0.377019 0.073381 C0.365601 0.086331 0.353269 0.099325 0.341622 0.112178 C0.350339 0.123429 0.359083 0.135499 0.367638 0.146945 C0.370998 0.151371 0.375711 0.156199 0.377052 0.161653 H0.352089 C0.348174 0.15906 0.337706 0.143834 0.334215 0.139193 C0.330475 0.134207 0.326643 0.129289 0.322725 0.124443 C0.321471 0.122869 0.318466 0.118792 0.316998 0.118035 C0.316124 0.118145 0.316252 0.118672 0.316272 0.119423 C0.316479 0.127394 0.316262 0.135418 0.316269 0.143394 C0.316272 0.14848 0.31663 0.153728 0.316282 0.158788 C0.316235 0.159492 0.316178 0.16047 0.315687 0.161026 C0.314714 0.162129 0.30172 0.161691 0.299336 0.161713 C0.297931 0.161726 0.295388 0.161927 0.294336 0.160809 C0.293736 0.160172 0.294047 0.081704 0.29405 0.073381 H0.316284 V0.106734 C0.32033 0.104672 0.324206 0.099317 0.327522 0.095984 C0.333973 0.089499 0.342486 0.078859 0.349529 0.073391 Z",
      "M0.559413 0.073357 H0.582423 L0.582413 0.104874 C0.58241 0.109272 0.582358 0.113995 0.582428 0.118356 C0.582514 0.124023 0.585802 0.134059 0.589795 0.138097 C0.592653 0.140948 0.596525 0.142552 0.600561 0.142561 C0.603951 0.142583 0.607207 0.141238 0.609594 0.138828 C0.612044 0.136362 0.615924 0.12844 0.616142 0.125333 C0.616453 0.120886 0.616292 0.114125 0.616292 0.109552 L0.61628 0.073357 H0.640171 V0.091684 L0.640188 0.111415 C0.640188 0.114488 0.640418 0.122673 0.640065 0.125376 C0.63866 0.134423 0.635364 0.143044 0.628824 0.149636 C0.613564 0.165017 0.586622 0.165153 0.571241 0.149922 C0.564961 0.1437 0.561336 0.134781 0.559668 0.12622 C0.558902 0.122286 0.559421 0.113822 0.559423 0.109489 L0.559413 0.073357 Z",
      "M0.326028 0.000322 C0.340814 -0.000349 0.359543 0.000158 0.374383 0.000672 C0.427786 0.002843 0.480981 0.008626 0.533604 0.017983 C0.545825 0.020057 0.558115 0.021816 0.570293 0.024104 C0.57416 0.025037 0.578576 0.025572 0.582358 0.026783 C0.591636 0.029751 0.60104 0.031111 0.610513 0.033286 C0.618808 0.035276 0.627086 0.037327 0.635349 0.03944 C0.639921 0.040564 0.644234 0.041143 0.648738 0.042211 C0.650587 0.04265 0.654329 0.044226 0.656201 0.044968 C0.652433 0.044839 0.647269 0.044472 0.643558 0.043696 C0.637709 0.042472 0.631787 0.040732 0.625908 0.039475 C0.612789 0.036707 0.599643 0.034072 0.586469 0.031571 C0.543741 0.023319 0.500646 0.017091 0.45733 0.012907 C0.453874 0.01231 0.44487 0.011804 0.441172 0.011515 C0.428013 0.010484 0.414837 0.009716 0.401646 0.009211 C0.319044 0.006114 0.228478 0.012653 0.15263 0.047914 C0.149387 0.047199 0.136863 0.044601 0.134916 0.043335 C0.134157 0.041299 0.13606 0.040462 0.137541 0.039734 C0.195825 0.011053 0.261637 0.001859 0.326028 0.000322 Z",
      "M0.24126 0.073397 C0.245553 0.073214 0.251211 0.073383 0.255591 0.073383 L0.28394 0.073381 C0.281901 0.079094 0.278086 0.087412 0.274961 0.092501 C0.271164 0.092682 0.267359 0.092706 0.26356 0.092573 C0.254902 0.092303 0.241676 0.090885 0.234703 0.096761 C0.225678 0.104365 0.225394 0.128213 0.232785 0.136759 C0.234565 0.138823 0.236867 0.140371 0.239451 0.141238 C0.24891 0.144391 0.271023 0.141541 0.282745 0.142414 C0.283115 0.142421 0.283469 0.142496 0.283834 0.142558 C0.284357 0.14454 0.28397 0.15857 0.28396 0.161654 L0.253006 0.161673 C0.249401 0.161674 0.239435 0.16191 0.236394 0.161277 C0.230845 0.159768 0.221958 0.156452 0.217728 0.152725 C0.200856 0.137862 0.200156 0.104122 0.213833 0.08708 C0.218988 0.080656 0.233179 0.074082 0.24126 0.073397 Z",
      "M0.407003 0.023302 C0.444253 0.022705 0.485401 0.025911 0.522406 0.029375 C0.527832 0.029863 0.533254 0.03039 0.538673 0.030956 C0.540823 0.031179 0.545358 0.031514 0.547235 0.032152 L0.547314 0.032426 C0.542551 0.033893 0.510736 0.030593 0.50408 0.030003 C0.498584 0.029499 0.493076 0.029117 0.487563 0.028857 C0.469324 0.028048 0.451064 0.027773 0.432807 0.028031 C0.386932 0.028215 0.341212 0.033387 0.296452 0.043456 C0.271078 0.049677 0.247019 0.057458 0.223444 0.068941 C0.220609 0.070322 0.217788 0.071743 0.215075 0.073356 C0.211289 0.075607 0.207494 0.078347 0.203503 0.080204 C0.200833 0.079665 0.189347 0.076793 0.187572 0.075263 L0.187566 0.074908 C0.195327 0.067864 0.211753 0.059674 0.221288 0.05566 C0.279854 0.030998 0.343977 0.023946 0.407003 0.023302 Z",
      "M0.915047 0.061439 C0.902762 0.076009 0.889484 0.09085 0.876933 0.105283 L0.811285 0.180769 C0.797237 0.159987 0.782552 0.138969 0.768799 0.118055 C0.779306 0.122367 0.789961 0.130598 0.799733 0.136502 C0.803631 0.138858 0.80825 0.141672 0.812489 0.143321 C0.817459 0.144429 0.820251 0.140821 0.823846 0.137906 L0.835388 0.128511 C0.85323 0.11373 0.870894 0.098735 0.888373 0.083527 L0.903529 0.070525 C0.906964 0.067593 0.911269 0.063713 0.915047 0.061439 Z",
      "M0.902273 0.085867 C0.904147 0.086291 0.905566 0.087767 0.906564 0.089349 C0.91777 0.107115 0.916222 0.137433 0.901132 0.152463 C0.897345 0.156289 0.892615 0.159045 0.88742 0.160451 C0.881248 0.162118 0.873128 0.161677 0.866547 0.161676 L0.846438 0.161659 H0.836763 C0.83916 0.156455 0.849603 0.145995 0.853778 0.141558 C0.860779 0.140971 0.875081 0.142605 0.880839 0.140737 C0.892909 0.13682 0.890832 0.110706 0.887909 0.102322 C0.89024 0.09971 0.900384 0.086776 0.902273 0.085867 Z",
      "M0.16837 0.081937 C0.173075 0.082006 0.185879 0.086053 0.189763 0.088717 C0.191419 0.09245 0.196281 0.112469 0.196891 0.116832 C0.194456 0.12115 0.185639 0.131469 0.181468 0.133873 C0.180333 0.133846 0.179228 0.133661 0.178105 0.133498 C0.170134 0.131617 0.163232 0.127614 0.154858 0.126196 C0.15289 0.122915 0.149222 0.10776 0.148741 0.103724 C0.151241 0.099433 0.164097 0.08444 0.16837 0.081937 Z",
      "M0.127418 0.057272 C0.137447 0.057277 0.147042 0.059122 0.156864 0.060255 C0.159494 0.064227 0.162404 0.07259 0.163201 0.077336 C0.160072 0.083698 0.150985 0.089877 0.146434 0.096616 C0.146302 0.096972 0.146036 0.097143 0.145731 0.097344 C0.143089 0.099078 0.127717 0.097047 0.124461 0.096324 C0.123668 0.096147 0.122398 0.095855 0.121938 0.095118 L0.121869 0.095005 C0.120742 0.093187 0.119096 0.089237 0.118154 0.087134 C0.116151 0.082711 0.114186 0.078272 0.112258 0.073817 C0.113522 0.069331 0.123317 0.05992 0.127418 0.057272 Z",
      "M0.152812 0.131262 C0.152996 0.131253 0.15318 0.131255 0.153364 0.131267 C0.155298 0.131388 0.176726 0.137701 0.178868 0.139486 C0.180693 0.141007 0.180665 0.150641 0.180177 0.153721 C0.176345 0.157078 0.163091 0.16484 0.158161 0.167604 C0.157011 0.168279 0.155674 0.168868 0.154461 0.16944 C0.149344 0.168594 0.140882 0.166556 0.136226 0.164387 C0.135224 0.160877 0.131986 0.146709 0.13274 0.143661 C0.133717 0.142205 0.149875 0.133009 0.152812 0.131262 Z",
      "M0.349803 0.016142 L0.349761 0.016375 C0.346078 0.017968 0.340232 0.017748 0.336348 0.018265 C0.328327 0.019361 0.320316 0.020526 0.312317 0.02176 C0.266646 0.028963 0.222843 0.0395 0.182623 0.06329 C0.179453 0.062219 0.174856 0.061095 0.171535 0.060172 C0.170193 0.059805 0.168858 0.059419 0.167528 0.059014 C0.167854 0.058607 0.168203 0.058218 0.168571 0.057849 C0.17008 0.05635 0.172573 0.054953 0.174449 0.053927 C0.220585 0.028696 0.274702 0.02158 0.326394 0.017361 C0.334153 0.016728 0.342044 0.016139 0.349803 0.016142 Z",
      "M0.105147 0.076604 C0.105794 0.076565 0.106363 0.076435 0.10686 0.076781 C0.109651 0.083522 0.114599 0.091772 0.11563 0.0984 C0.111016 0.105632 0.110479 0.11494 0.106782 0.121014 C0.103905 0.122022 0.09907 0.122818 0.096047 0.123352 C0.094012 0.123686 0.092545 0.123854 0.090488 0.124006 C0.088391 0.120836 0.085714 0.113512 0.085474 0.10946 C0.084998 0.101423 0.087227 0.087331 0.092101 0.080801 C0.094643 0.077394 0.101234 0.07687 0.105147 0.076604 Z",
      "M0.105071 0.127459 C0.105461 0.127367 0.107526 0.127263 0.108049 0.127227 C0.111951 0.130221 0.115817 0.134454 0.119575 0.137711 C0.121279 0.139188 0.123459 0.14058 0.125336 0.141893 C0.127294 0.146589 0.129152 0.158116 0.12919 0.163253 C0.123654 0.163957 0.121768 0.164741 0.115927 0.164599 C0.107336 0.163199 0.092114 0.147267 0.090946 0.138251 C0.090664 0.13608 0.090484 0.131749 0.091836 0.129964 C0.093591 0.128754 0.102553 0.127787 0.105071 0.127459 Z",
      "M0.83381 0.073357 C0.839044 0.073864 0.845883 0.07343 0.851245 0.073357 C0.86149 0.073219 0.871805 0.072955 0.881972 0.074566 C0.883263 0.07477 0.886665 0.075351 0.887717 0.075893 L0.887709 0.076523 C0.886771 0.078484 0.881258 0.082672 0.879288 0.084336 C0.877343 0.086035 0.870793 0.092247 0.868638 0.092332 C0.862093 0.09259 0.850122 0.093707 0.843861 0.092483 L0.843671 0.092445 C0.840464 0.091819 0.834822 0.076805 0.83381 0.073357 Z"
    ]
  },
  "fontCategories": [
    "Display",
    "Sport",
    "Sans",
    "Slab",
    "Handschrift"
  ],
  "fonts": [
    {
      "id": "Anton",
      "label": "Anton",
      "category": "Display",
      "family": "Anton"
    },
    {
      "id": "BebasNeue",
      "label": "Bebas Neue",
      "category": "Display",
      "family": "Bebas Neue"
    },
    {
      "id": "Staatliches",
      "label": "Staatliches",
      "category": "Display",
      "family": "Staatliches"
    },
    {
      "id": "ArchivoBlack",
      "label": "Archivo Black",
      "category": "Display",
      "family": "Archivo Black"
    },
    {
      "id": "Bungee",
      "label": "Bungee",
      "category": "Display",
      "family": "Bungee"
    },
    {
      "id": "BlackOpsOne",
      "label": "Black Ops One",
      "category": "Sport",
      "family": "Black Ops One"
    },
    {
      "id": "RubikMonoOne",
      "label": "Rubik Mono",
      "category": "Sport",
      "family": "Rubik Mono One"
    },
    {
      "id": "RussoOne",
      "label": "Russo One",
      "category": "Sport",
      "family": "Russo One"
    },
    {
      "id": "SquadaOne",
      "label": "Squada One",
      "category": "Sport",
      "family": "Squada One"
    },
    {
      "id": "Lato",
      "label": "Lato",
      "category": "Sans",
      "family": "Lato"
    },
    {
      "id": "FjallaOne",
      "label": "Fjalla One",
      "category": "Sans",
      "family": "Fjalla One"
    },
    {
      "id": "AlfaSlabOne",
      "label": "Alfa Slab",
      "category": "Slab",
      "family": "Alfa Slab One"
    },
    {
      "id": "PermanentMarker",
      "label": "Permanent Marker",
      "category": "Handschrift",
      "family": "Permanent Marker"
    },
    {
      "id": "Pacifico",
      "label": "Pacifico",
      "category": "Handschrift",
      "family": "Pacifico"
    },
    {
      "id": "Lobster",
      "label": "Lobster",
      "category": "Handschrift",
      "family": "Lobster"
    }
  ],
  "shapeCategories": [
    "Merk",
    "Basis",
    "Strepen"
  ],
  "shapeViewBox": 100,
  "shapes": [
    {
      "id": "circle",
      "label": "Cirkel",
      "category": "Basis",
      "d": "M50 2C76.51 2 98 23.49 98 50C98 76.51 76.51 98 50 98C23.49 98 2 76.51 2 50C2 23.49 23.49 2 50 2Z"
    },
    {
      "id": "ring",
      "label": "Ring",
      "category": "Basis",
      "d": "M50 2C76.51 2 98 23.49 98 50C98 76.51 76.51 98 50 98C23.49 98 2 76.51 2 50C2 23.49 23.49 2 50 2ZM50 22C34.54 22 22 34.54 22 50C22 65.46 34.54 78 50 78C65.46 78 78 65.46 78 50C78 34.54 65.46 22 50 22Z"
    },
    {
      "id": "square",
      "label": "Vierkant",
      "category": "Basis",
      "d": "M4 4H96V96H4Z"
    },
    {
      "id": "triangle",
      "label": "Driehoek",
      "category": "Basis",
      "d": "M50 4L96 92H4Z"
    },
    {
      "id": "diamond",
      "label": "Ruit",
      "category": "Basis",
      "d": "M50 2L98 50L50 98L2 50Z"
    },
    {
      "id": "hexagon",
      "label": "Zeshoek",
      "category": "Basis",
      "d": "M50 3L91 26.5V73.5L50 97L9 73.5V26.5Z"
    },
    {
      "id": "star",
      "label": "Ster",
      "category": "Merk",
      "d": "M50 3L61.8 36.6H97.6L68.9 57.4L79.9 92L50 71.2L20.1 92L31.1 57.4L2.4 36.6H38.2Z"
    },
    {
      "id": "shield",
      "label": "Schild",
      "category": "Merk",
      "d": "M50 3L92 16V52C92 74 72 90 50 97C28 90 8 74 8 52V16Z"
    },
    {
      "id": "lightning",
      "label": "Bliksem",
      "category": "Merk",
      "d": "M58 2L18 56H44L38 98L82 40H54Z"
    },
    {
      "id": "flame",
      "label": "Vlam",
      "category": "Merk",
      "d": "M50 2C58 22 78 30 78 54C78 78 64 98 50 98C36 98 22 78 22 54C22 42 30 36 34 44C38 52 44 44 44 32C44 20 46 10 50 2Z"
    },
    {
      "id": "cross",
      "label": "Kruis",
      "category": "Merk",
      "d": "M38 4H62V38H96V62H62V96H38V62H4V38H38Z"
    },
    {
      "id": "chevron",
      "label": "Punthaak",
      "category": "Strepen",
      "d": "M8 8L50 42L92 8V36L50 70L8 36Z"
    },
    {
      "id": "stripe",
      "label": "Streep",
      "category": "Strepen",
      "d": "M4 38H96V62H4Z"
    },
    {
      "id": "stripe-double",
      "label": "Dubbele streep",
      "category": "Strepen",
      "d": "M4 28H96V44H4ZM4 56H96V72H4Z"
    },
    {
      "id": "arrow-up",
      "label": "Pijl",
      "category": "Strepen",
      "d": "M50 2L92 48H68V98H32V48H8Z"
    },
    {
      "id": "banner",
      "label": "Wimpel",
      "category": "Strepen",
      "d": "M12 6H88V94L50 72L12 94Z"
    }
  ],
  "flags": [
    {
      "code": "af",
      "name": "Afghanistan"
    },
    {
      "code": "ax",
      "name": "Åland"
    },
    {
      "code": "al",
      "name": "Albanië"
    },
    {
      "code": "dz",
      "name": "Algerije"
    },
    {
      "code": "as",
      "name": "Amerikaans-Samoa"
    },
    {
      "code": "vi",
      "name": "Amerikaanse Maagdeneilanden"
    },
    {
      "code": "ad",
      "name": "Andorra"
    },
    {
      "code": "ao",
      "name": "Angola"
    },
    {
      "code": "ai",
      "name": "Anguilla"
    },
    {
      "code": "aq",
      "name": "Antarctica"
    },
    {
      "code": "ag",
      "name": "Antigua en Barbuda"
    },
    {
      "code": "ar",
      "name": "Argentinië"
    },
    {
      "code": "am",
      "name": "Armenië"
    },
    {
      "code": "aw",
      "name": "Aruba"
    },
    {
      "code": "au",
      "name": "Australië"
    },
    {
      "code": "az",
      "name": "Azerbeidzjan"
    },
    {
      "code": "bs",
      "name": "Bahama’s"
    },
    {
      "code": "bh",
      "name": "Bahrein"
    },
    {
      "code": "bd",
      "name": "Bangladesh"
    },
    {
      "code": "bb",
      "name": "Barbados"
    },
    {
      "code": "es-pv",
      "name": "Baskenland"
    },
    {
      "code": "by",
      "name": "Belarus"
    },
    {
      "code": "be",
      "name": "België"
    },
    {
      "code": "bz",
      "name": "Belize"
    },
    {
      "code": "bj",
      "name": "Benin"
    },
    {
      "code": "bm",
      "name": "Bermuda"
    },
    {
      "code": "bt",
      "name": "Bhutan"
    },
    {
      "code": "bo",
      "name": "Bolivia"
    },
    {
      "code": "ba",
      "name": "Bosnië en Herzegovina"
    },
    {
      "code": "bw",
      "name": "Botswana"
    },
    {
      "code": "bv",
      "name": "Bouveteiland"
    },
    {
      "code": "br",
      "name": "Brazilië"
    },
    {
      "code": "io",
      "name": "Brits Indische Oceaanterritorium"
    },
    {
      "code": "vg",
      "name": "Britse Maagdeneilanden"
    },
    {
      "code": "bn",
      "name": "Brunei"
    },
    {
      "code": "bg",
      "name": "Bulgarije"
    },
    {
      "code": "bf",
      "name": "Burkina Faso"
    },
    {
      "code": "bi",
      "name": "Burundi"
    },
    {
      "code": "kh",
      "name": "Cambodja"
    },
    {
      "code": "ca",
      "name": "Canada"
    },
    {
      "code": "ic",
      "name": "Canarische Eilanden"
    },
    {
      "code": "bq",
      "name": "Caribisch Nederland"
    },
    {
      "code": "es-ct",
      "name": "Catalonië"
    },
    {
      "code": "cf",
      "name": "Centraal-Afrikaanse Republiek"
    },
    {
      "code": "cl",
      "name": "Chili"
    },
    {
      "code": "cn",
      "name": "China"
    },
    {
      "code": "cx",
      "name": "Christmaseiland"
    },
    {
      "code": "cp",
      "name": "Clipperton"
    },
    {
      "code": "cc",
      "name": "Cocoseilanden"
    },
    {
      "code": "co",
      "name": "Colombia"
    },
    {
      "code": "km",
      "name": "Comoren"
    },
    {
      "code": "cg",
      "name": "Congo-Brazzaville"
    },
    {
      "code": "cd",
      "name": "Congo-Kinshasa"
    },
    {
      "code": "ck",
      "name": "Cookeilanden"
    },
    {
      "code": "cr",
      "name": "Costa Rica"
    },
    {
      "code": "cu",
      "name": "Cuba"
    },
    {
      "code": "cw",
      "name": "Curaçao"
    },
    {
      "code": "cy",
      "name": "Cyprus"
    },
    {
      "code": "dk",
      "name": "Denemarken"
    },
    {
      "code": "dg",
      "name": "Diego Garcia"
    },
    {
      "code": "dj",
      "name": "Djibouti"
    },
    {
      "code": "dm",
      "name": "Dominica"
    },
    {
      "code": "do",
      "name": "Dominicaanse Republiek"
    },
    {
      "code": "de",
      "name": "Duitsland"
    },
    {
      "code": "ec",
      "name": "Ecuador"
    },
    {
      "code": "eg",
      "name": "Egypte"
    },
    {
      "code": "sv",
      "name": "El Salvador"
    },
    {
      "code": "gb-eng",
      "name": "Engeland"
    },
    {
      "code": "gq",
      "name": "Equatoriaal-Guinea"
    },
    {
      "code": "er",
      "name": "Eritrea"
    },
    {
      "code": "ee",
      "name": "Estland"
    },
    {
      "code": "sz",
      "name": "Eswatini"
    },
    {
      "code": "et",
      "name": "Ethiopië"
    },
    {
      "code": "eu",
      "name": "Europese Unie"
    },
    {
      "code": "fo",
      "name": "Faeröer"
    },
    {
      "code": "fk",
      "name": "Falklandeilanden"
    },
    {
      "code": "fj",
      "name": "Fiji"
    },
    {
      "code": "ph",
      "name": "Filipijnen"
    },
    {
      "code": "fi",
      "name": "Finland"
    },
    {
      "code": "fr",
      "name": "Frankrijk"
    },
    {
      "code": "gf",
      "name": "Frans-Guyana"
    },
    {
      "code": "pf",
      "name": "Frans-Polynesië"
    },
    {
      "code": "tf",
      "name": "Franse Gebieden in de zuidelijke Indische Oceaan"
    },
    {
      "code": "ga",
      "name": "Gabon"
    },
    {
      "code": "es-ga",
      "name": "Galicië"
    },
    {
      "code": "gm",
      "name": "Gambia"
    },
    {
      "code": "ge",
      "name": "Georgië"
    },
    {
      "code": "gh",
      "name": "Ghana"
    },
    {
      "code": "gi",
      "name": "Gibraltar"
    },
    {
      "code": "gd",
      "name": "Grenada"
    },
    {
      "code": "gr",
      "name": "Griekenland"
    },
    {
      "code": "gl",
      "name": "Groenland"
    },
    {
      "code": "gp",
      "name": "Guadeloupe"
    },
    {
      "code": "gu",
      "name": "Guam"
    },
    {
      "code": "gt",
      "name": "Guatemala"
    },
    {
      "code": "gg",
      "name": "Guernsey"
    },
    {
      "code": "gn",
      "name": "Guinee"
    },
    {
      "code": "gw",
      "name": "Guinee-Bissau"
    },
    {
      "code": "gy",
      "name": "Guyana"
    },
    {
      "code": "ht",
      "name": "Haïti"
    },
    {
      "code": "hm",
      "name": "Heard en McDonaldeilanden"
    },
    {
      "code": "hn",
      "name": "Honduras"
    },
    {
      "code": "hu",
      "name": "Hongarije"
    },
    {
      "code": "hk",
      "name": "Hongkong SAR van China"
    },
    {
      "code": "ie",
      "name": "Ierland"
    },
    {
      "code": "is",
      "name": "IJsland"
    },
    {
      "code": "in",
      "name": "India"
    },
    {
      "code": "id",
      "name": "Indonesië"
    },
    {
      "code": "iq",
      "name": "Irak"
    },
    {
      "code": "ir",
      "name": "Iran"
    },
    {
      "code": "im",
      "name": "Isle of Man"
    },
    {
      "code": "il",
      "name": "Israël"
    },
    {
      "code": "it",
      "name": "Italië"
    },
    {
      "code": "ci",
      "name": "Ivoorkust"
    },
    {
      "code": "jm",
      "name": "Jamaica"
    },
    {
      "code": "jp",
      "name": "Japan"
    },
    {
      "code": "ye",
      "name": "Jemen"
    },
    {
      "code": "je",
      "name": "Jersey"
    },
    {
      "code": "jo",
      "name": "Jordanië"
    },
    {
      "code": "ky",
      "name": "Kaaimaneilanden"
    },
    {
      "code": "cv",
      "name": "Kaapverdië"
    },
    {
      "code": "cm",
      "name": "Kameroen"
    },
    {
      "code": "kz",
      "name": "Kazachstan"
    },
    {
      "code": "ke",
      "name": "Kenia"
    },
    {
      "code": "kg",
      "name": "Kirgizië"
    },
    {
      "code": "ki",
      "name": "Kiribati"
    },
    {
      "code": "um",
      "name": "Kleine afgelegen eilanden van de Verenigde Staten"
    },
    {
      "code": "kw",
      "name": "Koeweit"
    },
    {
      "code": "xk",
      "name": "Kosovo"
    },
    {
      "code": "hr",
      "name": "Kroatië"
    },
    {
      "code": "la",
      "name": "Laos"
    },
    {
      "code": "ls",
      "name": "Lesotho"
    },
    {
      "code": "lv",
      "name": "Letland"
    },
    {
      "code": "lb",
      "name": "Libanon"
    },
    {
      "code": "lr",
      "name": "Liberia"
    },
    {
      "code": "ly",
      "name": "Libië"
    },
    {
      "code": "li",
      "name": "Liechtenstein"
    },
    {
      "code": "lt",
      "name": "Litouwen"
    },
    {
      "code": "lu",
      "name": "Luxemburg"
    },
    {
      "code": "mo",
      "name": "Macau SAR van China"
    },
    {
      "code": "mg",
      "name": "Madagaskar"
    },
    {
      "code": "mw",
      "name": "Malawi"
    },
    {
      "code": "mv",
      "name": "Maldiven"
    },
    {
      "code": "my",
      "name": "Maleisië"
    },
    {
      "code": "ml",
      "name": "Mali"
    },
    {
      "code": "mt",
      "name": "Malta"
    },
    {
      "code": "ma",
      "name": "Marokko"
    },
    {
      "code": "mh",
      "name": "Marshalleilanden"
    },
    {
      "code": "mq",
      "name": "Martinique"
    },
    {
      "code": "mr",
      "name": "Mauritanië"
    },
    {
      "code": "mu",
      "name": "Mauritius"
    },
    {
      "code": "yt",
      "name": "Mayotte"
    },
    {
      "code": "mx",
      "name": "Mexico"
    },
    {
      "code": "fm",
      "name": "Micronesia"
    },
    {
      "code": "md",
      "name": "Moldavië"
    },
    {
      "code": "mc",
      "name": "Monaco"
    },
    {
      "code": "mn",
      "name": "Mongolië"
    },
    {
      "code": "me",
      "name": "Montenegro"
    },
    {
      "code": "ms",
      "name": "Montserrat"
    },
    {
      "code": "mz",
      "name": "Mozambique"
    },
    {
      "code": "mm",
      "name": "Myanmar (Birma)"
    },
    {
      "code": "na",
      "name": "Namibië"
    },
    {
      "code": "nr",
      "name": "Nauru"
    },
    {
      "code": "nl",
      "name": "Nederland"
    },
    {
      "code": "np",
      "name": "Nepal"
    },
    {
      "code": "ni",
      "name": "Nicaragua"
    },
    {
      "code": "nc",
      "name": "Nieuw-Caledonië"
    },
    {
      "code": "nz",
      "name": "Nieuw-Zeeland"
    },
    {
      "code": "ne",
      "name": "Niger"
    },
    {
      "code": "ng",
      "name": "Nigeria"
    },
    {
      "code": "nu",
      "name": "Niue"
    },
    {
      "code": "gb-nir",
      "name": "Noord-Ierland"
    },
    {
      "code": "kp",
      "name": "Noord-Korea"
    },
    {
      "code": "mk",
      "name": "Noord-Macedonië"
    },
    {
      "code": "mp",
      "name": "Noordelijke Marianen"
    },
    {
      "code": "no",
      "name": "Noorwegen"
    },
    {
      "code": "nf",
      "name": "Norfolk"
    },
    {
      "code": "ug",
      "name": "Oeganda"
    },
    {
      "code": "ua",
      "name": "Oekraïne"
    },
    {
      "code": "uz",
      "name": "Oezbekistan"
    },
    {
      "code": "om",
      "name": "Oman"
    },
    {
      "code": "tl",
      "name": "Oost-Timor"
    },
    {
      "code": "at",
      "name": "Oostenrijk"
    },
    {
      "code": "pk",
      "name": "Pakistan"
    },
    {
      "code": "pw",
      "name": "Palau"
    },
    {
      "code": "ps",
      "name": "Palestijnse gebieden"
    },
    {
      "code": "pa",
      "name": "Panama"
    },
    {
      "code": "pg",
      "name": "Papoea-Nieuw-Guinea"
    },
    {
      "code": "py",
      "name": "Paraguay"
    },
    {
      "code": "pe",
      "name": "Peru"
    },
    {
      "code": "pn",
      "name": "Pitcairneilanden"
    },
    {
      "code": "pl",
      "name": "Polen"
    },
    {
      "code": "pt",
      "name": "Portugal"
    },
    {
      "code": "pr",
      "name": "Puerto Rico"
    },
    {
      "code": "qa",
      "name": "Qatar"
    },
    {
      "code": "re",
      "name": "Réunion"
    },
    {
      "code": "ro",
      "name": "Roemenië"
    },
    {
      "code": "ru",
      "name": "Rusland"
    },
    {
      "code": "rw",
      "name": "Rwanda"
    },
    {
      "code": "kn",
      "name": "Saint Kitts en Nevis"
    },
    {
      "code": "lc",
      "name": "Saint Lucia"
    },
    {
      "code": "vc",
      "name": "Saint Vincent en de Grenadines"
    },
    {
      "code": "bl",
      "name": "Saint-Barthélemy"
    },
    {
      "code": "mf",
      "name": "Saint-Martin"
    },
    {
      "code": "pm",
      "name": "Saint-Pierre en Miquelon"
    },
    {
      "code": "sb",
      "name": "Salomonseilanden"
    },
    {
      "code": "ws",
      "name": "Samoa"
    },
    {
      "code": "sm",
      "name": "San Marino"
    },
    {
      "code": "st",
      "name": "Sao Tomé en Principe"
    },
    {
      "code": "sa",
      "name": "Saoedi-Arabië"
    },
    {
      "code": "gb-sct",
      "name": "Schotland"
    },
    {
      "code": "sn",
      "name": "Senegal"
    },
    {
      "code": "rs",
      "name": "Servië"
    },
    {
      "code": "sc",
      "name": "Seychellen"
    },
    {
      "code": "sl",
      "name": "Sierra Leone"
    },
    {
      "code": "sg",
      "name": "Singapore"
    },
    {
      "code": "sh",
      "name": "Sint-Helena"
    },
    {
      "code": "sx",
      "name": "Sint-Maarten"
    },
    {
      "code": "si",
      "name": "Slovenië"
    },
    {
      "code": "sk",
      "name": "Slowakije"
    },
    {
      "code": "sd",
      "name": "Soedan"
    },
    {
      "code": "so",
      "name": "Somalië"
    },
    {
      "code": "es",
      "name": "Spanje"
    },
    {
      "code": "sj",
      "name": "Spitsbergen en Jan Mayen"
    },
    {
      "code": "lk",
      "name": "Sri Lanka"
    },
    {
      "code": "sr",
      "name": "Suriname"
    },
    {
      "code": "sy",
      "name": "Syrië"
    },
    {
      "code": "tj",
      "name": "Tadzjikistan"
    },
    {
      "code": "tw",
      "name": "Taiwan"
    },
    {
      "code": "tz",
      "name": "Tanzania"
    },
    {
      "code": "th",
      "name": "Thailand"
    },
    {
      "code": "tg",
      "name": "Togo"
    },
    {
      "code": "tk",
      "name": "Tokelau"
    },
    {
      "code": "to",
      "name": "Tonga"
    },
    {
      "code": "tt",
      "name": "Trinidad en Tobago"
    },
    {
      "code": "td",
      "name": "Tsjaad"
    },
    {
      "code": "cz",
      "name": "Tsjechië"
    },
    {
      "code": "tn",
      "name": "Tunesië"
    },
    {
      "code": "tr",
      "name": "Turkije"
    },
    {
      "code": "tm",
      "name": "Turkmenistan"
    },
    {
      "code": "tc",
      "name": "Turks- en Caicoseilanden"
    },
    {
      "code": "tv",
      "name": "Tuvalu"
    },
    {
      "code": "uy",
      "name": "Uruguay"
    },
    {
      "code": "vu",
      "name": "Vanuatu"
    },
    {
      "code": "va",
      "name": "Vaticaanstad"
    },
    {
      "code": "ve",
      "name": "Venezuela"
    },
    {
      "code": "gb",
      "name": "Verenigd Koninkrijk"
    },
    {
      "code": "ae",
      "name": "Verenigde Arabische Emiraten"
    },
    {
      "code": "un",
      "name": "Verenigde Naties"
    },
    {
      "code": "us",
      "name": "Verenigde Staten"
    },
    {
      "code": "vn",
      "name": "Vietnam"
    },
    {
      "code": "gb-wls",
      "name": "Wales"
    },
    {
      "code": "wf",
      "name": "Wallis en Futuna"
    },
    {
      "code": "eh",
      "name": "Westelijke Sahara"
    },
    {
      "code": "zm",
      "name": "Zambia"
    },
    {
      "code": "zw",
      "name": "Zimbabwe"
    },
    {
      "code": "za",
      "name": "Zuid-Afrika"
    },
    {
      "code": "gs",
      "name": "Zuid-Georgia en Zuidelijke Sandwicheilanden"
    },
    {
      "code": "kr",
      "name": "Zuid-Korea"
    },
    {
      "code": "ss",
      "name": "Zuid-Soedan"
    },
    {
      "code": "se",
      "name": "Zweden"
    },
    {
      "code": "ch",
      "name": "Zwitserland"
    }
  ],
  "flagPath": "/storage/v1/object/public/assets/flags/"
};
